import { DocumentManagerActions } from '@/components/modules/Documentation/components/DocumentationHeader/types/documentManagerActions';
import { documentationEditModeMapper } from '@/components/modules/Documentation/maps/documentationEditModeMapper';
import { DocumentationCapability } from '@/components/modules/Documentation/types/DocumentationCapability';
import { DocumentationMode } from '@/components/modules/Documentation/types/DocumentationMode';
import { Text } from '@/components/shared/components/Text';

export const useDocumentationHeaderActions = ({
  onClickAction,
  loanApplicationId,
}: {
  onClickAction: (action: DocumentManagerActions) => void;
  loanApplicationId?: string;
}) => {
  const SendAllDocuments = {
    display: <Text tId={'SEND_ALL_DOCUMENTS'} />,
    iconName: 'send',
    onClick: () => onClickAction(DocumentManagerActions.SEND_ALL_DOCUMENTS),
    disabled: !loanApplicationId,
  };
  const SynchronizeDocuments = {
    display: <Text tId={'SYNCHRONIZE_DOCUMENTS'} />,
    iconName: 'sync_alt',
    onClick: () => onClickAction(DocumentManagerActions.SYNCHRONIZE_DOCUMENTS),
  };

  const getActionOptionsArray = (mode: DocumentationMode) => {
    const documentationCapabilities = documentationEditModeMapper(mode);

    return documentationCapabilities
      .flatMap((capability) => {
        switch (capability) {
          case DocumentationCapability.LENDER_SEND:
            return SendAllDocuments;
          case DocumentationCapability.LENDER_SYNC:
            return SynchronizeDocuments;
        }
      })
      .filter((el) => el !== undefined);
  };

  return { getActionOptionsArray };
};
